import { type Repub } from '@cx-modules/types';

import { REPUB_CONFIG } from '~/repub-config';

import { ErrorWhoScored, ErrorWithoutTranslation, ErrorWithTranslation } from './components';

export function RootErrorPage({
  baseUrl,
  errorStatus,
  repub,
  rootLoaderData,
  statusLogoPng,
  t,
  translationReady,
}: {
  baseUrl: string;
  errorStatus: number | null;
  repub: Repub;
  rootLoaderData: any;
  statusLogoPng: string;
  t: (key: string) => string;
  translationReady: boolean;
}) {
  // Check if repub has a custom error page component
  const customComponentId = REPUB_CONFIG[repub]?.plus?.errorPage?.customComponent;

  if (customComponentId === 'ErrorWhoScored') {
    return <ErrorWhoScored baseUrl={baseUrl} />;
  }

  return (
    <>
      {translationReady ? (
        <ErrorWithTranslation baseUrl={baseUrl} rootLoaderData={rootLoaderData} statusLogoPng={statusLogoPng} t={t} />
      ) : (
        <ErrorWithoutTranslation
          baseUrl={baseUrl}
          errorStatus={errorStatus}
          repub={repub}
          rootLoaderData={rootLoaderData}
        />
      )}
    </>
  );
}
